<template>
    <div class="row m-0">
        <div class="col-12">
            <div class="row headers text-dark text-center py-3">
                <h4 class="m-0 mx-auto"> {{ $t("achievement") }} </h4>
            </div>
            <div class="row">
                <div class="sections p-3">
                    <div class="card w-100 border-0">
                        <div class="card-title mb-0">
                            <div class="float-left">
                                <div class="media mt-2">
                                    <img src="@/assets/images/nokhbegan.png" class="place-logos img-thumbnail border-0" alt="sanjesh">
                                    <div class="media-body ml-2">
                                        <span class="d-block"> {{ $t("phd_rank") }} </span>
                                        <span class="d-block"> PhD Entrance Exam of Medical Genetics </span>
                                    </div>
                                </div>
                            </div>
                            <div class="float-right">
                                <small> {{ $t("phd_time") }} </small>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="w-100">
                            <div class="float-left">

                            </div>
                            <div class="float-right">

                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="card w-100 border-0 mt-4">
                        <div class="card-title mb-0">
                            <div class="float-left">
                                <div class="media mt-2">
                                    <img src="@/assets/images/nokhbegan.png" class="place-logos img-thumbnail border-0" alt="sanjeshp">
                                    <div class="media-body ml-2">
                                        <span class="d-block"> {{ $t("dr_rank") }} </span>
                                        <span class="d-block"> Nationally Distinguished Researcher </span>
                                    </div>
                                </div>
                            </div>
                            <div class="float-right">
                                <small> {{ $t("dr_time") }} </small>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="w-100">
                            <div class="float-left">

                            </div>
                            <div class="float-right">

                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="card w-100 border-0 mt-4">
                        <div class="card-title mb-0">
                            <div class="float-left">
                                <div class="media mt-2">
                                    <img src="@/assets/images/sanjesh.png" class="place-logos img-thumbnail border-0" alt="sanjesh">
                                    <div class="media-body ml-2">
                                        <span class="d-block"> {{ $t("nbo_rank") }} - <small> {{ $t("stage") }} </small> </span>
                                        <span class="d-block"> National Biology Olympiad </span>
                                    </div>
                                </div>
                            </div>
                            <div class="float-right">
                                <small> {{ $t("nbo_time") }} </small>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="w-100">
                            <div class="float-left">

                            </div>
                            <div class="float-right">

                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="text-center">
                        <vs-button class="d-inline mt-3" transparent active color="dark" data-toggle="collapse" data-target="#collapseAchievement" aria-expanded="false" aria-controls="collapseAchievement">
                            {{ $t("more") }}
                        </vs-button>
                    </div>
                    <div class="collapse" id="collapseAchievement">
                        <div class="card w-100 border-0 mt-1">
                            <div class="card-title mb-0">
                                <div class="float-left">
                                    <div class="media mt-2">
                                        <img src="@/assets/images/nokhbegan.png" class="place-logos img-thumbnail border-0" alt="sanjeshp">
                                        <div class="media-body ml-2">
                                            <span class="d-block"> {{ $t("mhg_rank") }} - <small> 3000 {{ $t("participant") }} </small> </span>
                                            <span class="d-block"> Master Entrance Exam of Human Genetics </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="float-right">
                                    <small> {{ $t("mhg_time") }} </small>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="w-100">
                                <div class="float-left">

                                </div>
                                <div class="float-right">

                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <div class="card w-100 border-0 mt-4">
                            <div class="card-title mb-0">
                                <div class="float-left">
                                    <div class="media mt-2">
                                        <img src="@/assets/images/sanjesh.png" class="place-logos img-thumbnail border-0" alt="sanjesh">
                                        <div class="media-body ml-2">
                                            <span class="d-block"> {{ $t("mg_rank") }} - <small> 10000 {{ $t("participant") }} </small> </span>
                                            <span class="d-block"> Master Entrance Exam of Genetics </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="float-right">
                                    <small> {{ $t("mg_time") }} </small>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="w-100">
                                <div class="float-left">

                                </div>
                                <div class="float-right">

                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <div class="card w-100 border-0 mt-4">
                            <div class="card-title mb-0">
                                <div class="float-left">
                                    <div class="media mt-2">
                                        <img src="@/assets/images/iaum.png" class="place-logos img-thumbnail border-0" alt="sanjesh">
                                        <div class="media-body ml-2">
                                            <span class="d-block"> {{ $t("tg_rank") }} - <small> 18.29/20 </small> </span>
                                            <span class="d-block"> Bachelor Degree of the Medical Laboratory Science Field </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="float-right">
                                    <small> {{ $t("tg_time") }} </small>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="w-100">
                                <div class="float-left">

                                </div>
                                <div class="float-right">

                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Achievement",
        data() {
            return {

            }
        },
        mounted() {

        },
        methods : {

        }
    }
</script>

<style>

</style>

<style scoped>

</style>
